import { render } from "./product-compatibility.vue?vue&type=template&id=396b6213"
import script from "./product-compatibility.vue?vue&type=script&lang=js"
export * from "./product-compatibility.vue?vue&type=script&lang=js"

import "./product-compatibility.vue?vue&type=style&index=0&id=396b6213&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__